'use client';

import { c as _c } from "react/compiler-runtime";
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { AppCombobox } from '@/components/elementary/AppCombobox';
import { AppForm } from '@/components/forms/AppForm';
import { Paragraph } from '@/components/typography/Paragraph';
import { Button } from '@/components/ui/button';
import { useRouter } from '@/i18n/navigation';
import { companySizeKeys, industryKeys, languageKeys } from '@/lib/constants';
import { CASE_STUDIES_FILTERS_TEST_IDS } from '@/lib/test-ids';
export function CaseStudyFilterForm(t0) {
  const $ = _c(58);
  const {
    integrations
  } = t0;
  const t = useTranslations("CaseStudyFilterForm");
  const tIndustry = useTranslations("industry");
  const tCompanySize = useTranslations("companySize");
  const tLanguage = useTranslations("language");
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: standardSchemaResolver(FilterFormSchema),
      mode: "onBlur",
      reValidateMode: "onSubmit"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  let t2;
  if ($[1] !== tIndustry) {
    t2 = industryKeys.map(key => ({
      value: key,
      label: tIndustry(key)
    }));
    $[1] = tIndustry;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const industryOptions = t2;
  let t3;
  if ($[3] !== tCompanySize) {
    t3 = companySizeKeys.map(key_0 => ({
      value: key_0,
      label: tCompanySize(key_0)
    }));
    $[3] = tCompanySize;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const companySizeOptions = t3;
  let t4;
  if ($[5] !== tLanguage) {
    t4 = languageKeys.map(key_1 => ({
      value: key_1,
      label: tLanguage(key_1)
    }));
    $[5] = tLanguage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const languagesOptions = t4;
  let t5;
  if ($[7] !== integrations) {
    t5 = integrations.map(_temp);
    $[7] = integrations;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const integrationOptions = t5;
  const buildQueryParams = _temp2;
  let t6;
  if ($[9] !== router) {
    t6 = values_0 => {
      const queryParams = buildQueryParams(values_0);
      router.push({
        pathname: "/case-studies",
        query: queryParams
      }, {
        scroll: false
      });
    };
    $[9] = router;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const onSubmit = t6;
  let t7;
  if ($[11] !== form || $[12] !== router) {
    t7 = () => {
      form.reset();
      router.push({
        pathname: "/case-studies"
      }, {
        scroll: false
      });
    };
    $[11] = form;
    $[12] = router;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const clearFilters = t7;
  let t8;
  if ($[14] !== t) {
    t8 = t("industry");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== industryOptions || $[17] !== t8) {
    t9 = <AppCombobox name="industry" values={industryOptions} noDataMessage="Nothing matched your query." placeholder={t8} data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_TRIGGER} containerClassName="w-full md:flex-1" fieldClassName="w-full pr-1" />;
    $[16] = industryOptions;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("integrations");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== integrationOptions || $[22] !== t10) {
    t11 = <AppCombobox name="integrations" values={integrationOptions} noDataMessage="No integrations found." placeholder={t10} data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_TRIGGER} containerClassName="w-full md:flex-1" fieldClassName="w-full pr-1" />;
    $[21] = integrationOptions;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("companySize");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== companySizeOptions || $[27] !== t12) {
    t13 = <AppCombobox name="company" values={companySizeOptions} noDataMessage="Nothing matched your query." placeholder={t12} data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_TRIGGER} containerClassName="w-full md:flex-1" fieldClassName="w-full pr-1" />;
    $[26] = companySizeOptions;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("targetLanguages");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== languagesOptions || $[32] !== t14) {
    t15 = <AppCombobox name="language" values={languagesOptions} noDataMessage="Nothing matched your query." placeholder={t14} data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_TRIGGER} containerClassName="w-full md:flex-1" fieldClassName="w-full pr-1" />;
    $[31] = languagesOptions;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t11 || $[35] !== t13 || $[36] !== t15 || $[37] !== t9) {
    t16 = <div className="gap-2 lg:gap-3 lg:flex lg:flex-wrap md:whitespace-nowrap lg:flex-row grid grid-cols-1 sm:grid-cols-2 w-full lg:max-w-180">{t9}{t11}{t13}{t15}</div>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t15;
    $[37] = t9;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t) {
    t17 = t("applyFilters");
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <Button type="submit" data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_APPLY_FILTERS}>{t17}</Button>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t("clearFilters");
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t19) {
    t20 = <Paragraph fontSize="bodyRegularMedium" className="underline hover:text-brand-salmon active:text-brand-salmon">{t19}</Paragraph>;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== clearFilters || $[48] !== t20) {
    t21 = <Button type="button" variant="primaryLink" onClick={clearFilters} data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.FILTER_CLEAR_FILTERS}>{t20}</Button>;
    $[47] = clearFilters;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t18 || $[51] !== t21) {
    t22 = <div className="flex justify-between flex-col sm:flex-row flex-1 whitespace-nowrap gap-2">{t18}{t21}</div>;
    $[50] = t18;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== form || $[54] !== onSubmit || $[55] !== t16 || $[56] !== t22) {
    t23 = <div className="p-4 gap-5 lg:gap-3 items-center flex lg:p-8 lg:flex-row flex-col justify-between rounded-xl bg-peach-300"><AppForm form={form} id={filterFormName} onSubmit={onSubmit} className="flex w-full" fieldsetClassname="gap-5 lg:gap-3 w-full flex items-center lg:flex-row flex-col justify-between">{t16}{t22}</AppForm></div>;
    $[53] = form;
    $[54] = onSubmit;
    $[55] = t16;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
}
function _temp2(values) {
  const params = {};
  const mappings = [["industry", "industry"], ["integrations", "integrations"], ["company", "company_size"], ["language", "target_languages"]];
  for (const [key_2, queryParam] of mappings) {
    const valueArray = values[key_2];
    if (Array.isArray(valueArray) && valueArray.length) {
      params[queryParam] = valueArray;
    }
  }
  return params;
}
function _temp(item) {
  return {
    value: item.documentId,
    label: item.title ?? ""
  };
}
const FilterFormSchema = z.object({
  industry: z.array(z.string()).optional(),
  integrations: z.array(z.string()).optional(),
  company: z.array(z.string()).optional(),
  language: z.array(z.string()).optional()
});
type FormSchemaType = typeof FilterFormSchema;
export const filterFormName = 'caseStudiesFilters';